export const colors = {
  primary: {
    50: "#f7eafb",
    100: "#e6bff3",
    200: "#d594ea",
    300: "#c469e2",
    400: "#b33fda",
    500: "#9a25c0",
    600: "#701B8C",
    700: "#56156b",
    800: "#330c40",
    900: "#110415",
  },
  secondary: {
    400: "#EEFF01",
  },
  error: {
    400: "#CC1D14",
  },
  text: {
    200: "#A1A6B3",
    300: "#717A8C",
    400: "#515C6F",
    500: "#3D434D",
    600: "#3A3A3A",
  },
  background: {
    300: "#F5F6F8",
    400: "#f3f3f3",
    500: "#E3E4E6",
    600: "#C3CAD9",
  },
  white: {
    50: "#FFFFFF",
    100: "#FFFFFF",
    200: "#FFFFFF",
    300: "#FFFFFF",
    400: "#FFFFFF",
    500: "#FFFFFF",
    600: "#FFFFFF",
    700: "#E3E4E6",
    800: "#C3CAD9",
    900: "#A1A6B3",
  },
};
